import * as CONFIG from '../constants/config/filters'
import { round } from './magnitudes'

/**
 * @name formatBasic
 * @constant
 * @function
 * @description Formats the basic parameter object that is utilized by all 
 * @param {Object} parameter 
 * @param {Object} config 
 * @param {string} format
 */
export const formatBasic = ( parameter, config, format ) => {
    let formattedParameter = {
        allowBlanks: Boolean( config.matchNull ),
        default: ( parameter.display_in_default_view === 'true' ),
        format,
        id: parameter.field,
        name: parameter.external_name,
        tooltip: parameter.tooltip,
        s3Type: parameter.s3Type
    };

    if( parameter.uom && parameter.uom !== 'n/a' ) formattedParameter.uom = parameter.uom;

    if( config.minMaxTyp && config.minMaxTyp !== '' ) formattedParameter.delay = config.minMaxTyp;

    if( formattedParameter.default ){
        if( !window.defaultParams ) window.defaultParams = [];
        window.defaultParams.push( formattedParameter.id )
    }

    return formattedParameter;
}

/**
 * @name formatCheckboxes
 * @constant
 * @function
 * @description Formats the checkbox parameter
 * @param {Object} parameter 
 * @param {Object} config 
 */
export const formatCheckboxes = ( parameter, config ) => {

    let formattedParameter = formatBasic( parameter, config, 'checkbox' );

    formattedParameter.options = parameter.values ? parameter.values.map( value => ({ value, disabled: false }) ) : [];

    return formattedParameter;

}

/**
 * @name formatRange
 * @constant
 * @function
 * @description Formats the range parameter
 * @param {*} parameter 
 * @param {*} config 
 * @param {array} increments
 */
export const formatRange = ( parameter, config, increments ) => {

    let formattedParameter = formatBasic( parameter, config, 'range' ),
    formattedIncrements = [];

    increments.forEach( increment => {
        let number = Number( increment );
        if( increment === "" || number > formattedParameter.max || number < formattedParameter.min ) return;
        formattedIncrements.push( number );
    });

    formattedIncrements = formattedIncrements.sort( ( a, b ) => {
        if( a > b ) return 1;
        if( a < b ) return -1;
        return 0;
    });

    formattedParameter.magnitude = Boolean( config.hasMagnitude );
    formattedParameter.max = Number( parameter.max );
    formattedParameter.min = Number( parameter.min );

    // limit increments to 10 options
    formattedParameter.increments = reduceIncrements( formattedIncrements );

    if( !formattedParameter.increments.includes( formattedParameter.min ) ){
        if( formattedParameter.increments.length >= CONFIG.SLIDER_MAX_INCREMENT ) formattedParameter.increments.shift();
        formattedParameter.increments.unshift( formattedParameter.min );
    }
    if( !formattedParameter.increments.includes( formattedParameter.max ) ){
        if( formattedParameter.increments.length >= CONFIG.SLIDER_MAX_INCREMENT ) formattedParameter.increments.pop();
        formattedParameter.increments.push( formattedParameter.max );
    }

    return formattedParameter;

}

/**
 * @name reduceIncrements
 * @constant
 * @function
 * @description Create the range for a slider
 * @param {array} values 
 */
export const reduceIncrements = values => {

    // limit increments to be 10 median
    if( values.length <= CONFIG.SLIDER_MAX_INCREMENT ) return values;

    let tempValues = [ ...values ],
    upperLimit = tempValues.pop(),
    lowerLimit = tempValues.shift(),
    range = ( upperLimit - lowerLimit ),
    incrementor = ( range / CONFIG.SLIDER_MAX_INCREMENT ),
    increments = [];

    for( let i = lowerLimit; i < upperLimit; i += incrementor ) increments.push( i < 1 ? i : round( i ) );

    return increments;
  
}

/**
 * @name formatText
 * @constant
 * @function
 * @description Formats the text parameter
 * @param {*} parameter 
 * @param {*} config 
 */
export const formatText = ( parameter, config ) => formatBasic( parameter, config, 'text' );

/**
 * @name debounce
 * @constant
 * @function
 * @description Debounces the action with a delay
 * @param {*} func 
 * @param {*} delay 
 */
export const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
